import { Aufnahmebogen } from './Aufnahmebogen';
import { IDs } from '../../../helpers/IDs';
import { ImportConstants } from '../ImportConstants';
import * as Moment from 'moment';

export class AufnahmebogenKraftstoffe extends Aufnahmebogen {

    private curEnergietraeger: string;
    private curMesssystemIndex: number;
    protected dataIgnored: any = {};

    constructor(dataSheet: Array<any>, dataDb: any) {
        super(dataSheet, dataDb);

        if (dataSheet.length) {
            this.setData();
        }
    }

    public getData(): Array<any> {
        const data: any = this.data;

        Object.keys(data).forEach((entity: any) => {
            data[entity] = this.getDataValided(data[entity]);
            const compare: Array<any> = this.dataIgnored[entity].map((item: any) => `${item.jahr}-${item.energietraeger_tid}`);
            data[entity] = data[entity].filter((row: any) => compare.indexOf(`${row.jahr}-${row.energietraeger_tid}`) === -1);
        });

        return data;
    }

    protected getDataValided(data: Array<any>): Array<any> {
        return data.filter((row: any) =>
            row.kosten
            || row.verbrauch
        );
    }

    protected getEnergietraegerTid(): string {
        return ((this.dataDb[IDs.ENT_ENERGIEDATEN_KRAFTSTOFF_ENERGIETRAEGER] || [])
            .find((einheit: any) => einheit.name === `${this.curEnergietraeger} [${this.getEinheit()}]`) || {}).tid || null;
    }

    private setAbrechnungszeitraumJahr(): void {
        this.callValues(0, (jahr: number, index: number) => {
            if (jahr) {
                const abrechnungszeitraum_bis = Moment([jahr, 11, 31, 23, 59, 59]);
                const abrechnungszeitraum_von = Moment([jahr, 0, 1, 0, 0, 0]);
                this.data[this.curEntity][index].abrechnungstage = Moment(abrechnungszeitraum_bis).diff(abrechnungszeitraum_von, 'd') + 1;
                this.data[this.curEntity][index].abrechnungszeitraum_bis = Moment(abrechnungszeitraum_bis).unix();
                this.data[this.curEntity][index].abrechnungszeitraum_von = Moment(abrechnungszeitraum_von).unix();
            }
        });
    }

    private setData(): void {
        let sub: number = 0;

        this.dataSheet.forEach((row: Array<string>, index: number) => {
            this.curRowIndex = index;
            const titel: string = this.getTitel() || null;

            if (this.isHeaderRow(row)) {
                this.curMesssystemIndex = this.dataSheet.findIndex((row2: any, index2) =>
                    index2 > index
                    && row2[ImportConstants.COL_AUFNAHME_TITEL] === 'Mess-System (Kalibrierung)'
                );
            } else if ((row.length === 35 || row.length === 37) && row[2] && row[4] && titel !== 'Mess-System (Kalibrierung)') {
                this.initData(IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE, ++sub);
                this.setJahre();
                this.curEnergietraeger = titel;
                this.setAbrechnungszeitraumJahr();
                this.setEnergietraeger();
                this.setMesssystem();
            }

            if (this.curEnergietraeger) {
                this.setBemerkung();
            }
        });
        this.setDataIgnored();
    }

    private setDataIgnored(): void {
        const entity: string = IDs.ENT_ENERGIEDATEN_KRAFTSTOFFE;
        const data: any = this.getDataValided(this.data[entity] || []);
        this.dataIgnored[entity] = [];

        data.forEach((row: any, index: number) => {
            const jahr: number = row.jahr || null;

            if (this.dataDb[entity].some((row: any) => row.jahr === jahr)) {
                this.dataIgnored[entity].push(data[index]);
            }
        });
    }

    protected setEnergietraeger(): void {
        this.setValue('verbrauch', (value: any, index: number) => {
            if (typeof value === 'number') {
                this.data[this.curEntity][index].verbrauch = +value.toFixed(2);
            }
            this.curEnergietraeger = this.curEnergietraeger
                .replace('Ottokraftstoff', 'Benzin')
                .replace('Dieselkraftstoff', 'Diesel')
                .replace('Ladestrom\r\n(E-Mobil)', 'Ladestrom');
            this.data[this.curEntity][index].energietraeger_tid = this.getEnergietraegerTid();
        });
        ++this.curRowIndex;
        this.setValue('kosten', (value: any, index: number) => {
            if (typeof value === 'number') {
                this.data[this.curEntity][index].kosten = +value.toFixed(2);
            }
        });
    }

    protected setMesssystem(): void {
        const curRowIndex: number = this.curRowIndex;
        this.curRowIndex = this.curMesssystemIndex;
        this.setValue('messsystem');
        this.curRowIndex = curRowIndex - 1;
    }
}
